// extracted by mini-css-extract-plugin
module.exports = {"svgHeightWidth":"IconBadge__svgHeightWidth___1DpGG"};